export default {
  All: 'all',
  Open: 'open',
  Closed: 'closed',
  Declined: 'declined',
}
